<!--
 * @Description: 加载动画
 * @Author: 山淑兰
 * @Date: 2019-11-12 10:36:09
 * @LastEditTime : 2019-12-21 21:47:01
 * @LastEditors  : 山淑兰
 -->
<template>
  <div id="loading">
    <div class="loading_con">
      <div class="loading-blue"></div>
      <img src="@assets/loading.png" alt />
      <div class="loadingText">努力加载中...</div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'loading',

}
</script>
<style lang="scss" scoped>
@keyframes fadeUp {
  0% {
    height: 0%;
  }
  100% {
    height: 100%;
  }
}
#loading {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
  z-index: 99999;
  overflow: hidden;
}
.loading_con {
  width: 140px;
  height: 140px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(20px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}
#loading img {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}
.loading-blue {
  animation: fadeUp 2s linear 1s infinite alternate;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(to top, #3b82f6, #818cf8);
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);
  z-index: 0;
}
.loadingText {
  position: absolute;
  bottom: -56px;
  width: 200px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 28px;
}
</style>
